module.exports = __webpack_public_path__ + "img/cognitive_img06.59eedaa7.png";